import { createSlice } from '@reduxjs/toolkit';
import { fetchCommunityByCommunityName} from '../CommunityAPI/communityApi';

const communityByNameSlice = createSlice({
  name: 'communityByName',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchCommunityByCommunityName.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommunityByCommunityName.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCommunityByCommunityName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});
export default communityByNameSlice.reducer;
